import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseCircleOutlined } from "@ant-design/icons";
import styles from "./BadgeList.module.scss";
const BadgeList = ({ values, onClickDelete, onClickBold, className, }) => {
    return (_jsx("div", Object.assign({ className: `${styles.container} ${className}` }, { children: (values !== null && values !== void 0 ? values : []).map((value, index) => (_jsxs("span", Object.assign({ className: styles.item, onClick: () => onClickBold(value.value) }, { children: [_jsx("p", Object.assign({ style: {
                        fontWeight: value.emphasized ? "bold" : "normal",
                        margin: 0,
                        padding: 0,
                    } }, { children: value.value }), void 0), _jsx(CloseCircleOutlined, { onClick: (e) => {
                        e.stopPropagation();
                        onClickDelete(value.value);
                    } }, void 0)] }), index))) }), void 0));
};
export default BadgeList;
